// Phase 1 turtle candidates (removed from pickers when Phase 2 launched).
// Provider identities stay on the server. These helpers remain only to detect
// saved standalone values for fallback and to render historical cards/ledger
// provenance — they must not gate new selections.
const MUSE2_ALPHA_WRITE_MODELS = new Set(["muse2Leonardo", "muse2Michelangelo", "muse2Donatello", "muse2Raphael"]);
const MUSE2_ALPHA_MODEL_LABELS = new Set(["Leonardo", "Raphael", "Donatello", "Michelangelo"]);

// History cards carry the display label (chiclets.model) on both Write and
// Draft, so it identifies an alpha generation without exposing anything new.
export function isMuse2AlphaModelLabel(label) {
  return typeof label === "string" && MUSE2_ALPHA_MODEL_LABELS.has(label);
}

export function isMuse2AlphaWriteModel(modelId) {
  return typeof modelId === "string" && MUSE2_ALPHA_WRITE_MODELS.has(modelId);
}

export function resolveMuse2AlphaWriteModelAccess(modelId, hasAccess, fallbackModelId) {
  return isMuse2AlphaWriteModel(modelId) && !hasAccess ? fallbackModelId : modelId;
}

// The alpha candidates share one style sample, siloed from the field the
// regular prose modes read. Until a tester saves an alpha-specific sample the
// silo is unset, and reads fall back to their legacy sample so nobody's alpha
// Draft silently runs with an empty style sample mid-experiment. An explicitly
// cleared silo ("" after the user empties the box) does NOT fall back.
export const MUSE2_ALPHA_STYLE_FIELD = "muse2AlphaStyleExamples";

export function resolveDraftStyleSample(userDataData, muse2Alpha) {
  if (!muse2Alpha) return userDataData?.userStyleExamples || "";
  return userDataData?.[MUSE2_ALPHA_STYLE_FIELD] ?? userDataData?.userStyleExamples ?? "";
}
